import { render, staticRenderFns } from "./ReceptionUpsert.vue?vue&type=template&id=6bbee5d3&"
import script from "./ReceptionUpsert.vue?vue&type=script&lang=js&"
export * from "./ReceptionUpsert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports